module.exports = __webpack_public_path__ + "static/img/index_green.da63bb4f.png";